import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import Header from "../elements/Header/Header";
import InputText from "../components/InputTextSlide/InputTextSlide";

import './Slideshow.css'
import Button from "../components/Button/Button";

import { API_URL } from "../constans/roles";
import Loading from "../elements/LoadingScreen/Loading";
import { useStateValue } from "../stateProvider/stateProvider";
import fetchGet from "../utils/fetch";

import { LOGOUT, SET_FILTERS_DATA } from "../constans/reducerActions";
import { balansSort } from "../utils/utilities";

const App = () => {
  const defauultForma = {
    kampania: "",
    klient: "",
    branza: "",
    format: "",
  }
  const [reducer,dispatch] = useStateValue()
  const [formData, setFormData] = useState(defauultForma);
  const [files, setFiles] = useState([]);
  const [message,setMessage] = useState("");
  const [loading,setLoading] = useState(false);
  const [copyTxt,setCopyTxt] = useState("Kopiuj")

  const onDrop = (acceptedFiles) => {
    const mappedFiles = acceptedFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
    );
    setFiles([...files, ...mappedFiles]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/avif": [".avif"],
      "image/gif": [".gif"],
      "image/webp": [".webp"],
      "video/webm": [".webm"],
      "video/mp4": [".mp4"],
    },
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const data = new FormData();
    data.append("kampania", formData.kampania);
    data.append("klient", formData.klient);
    data.append("branza", formData.branza);
    data.append("format", formData.format);

    console.log(formData)

    files.forEach((file) => {
      data.append("files", file);
    });

    setLoading(true)

    try {
      const response = await fetch(API_URL+ '/' + "api/slideshow/upload", {
        method: "POST",
        body: data,
      });

      if (!response.ok) {
        throw new Error("Upload failed!");
      }

      const result = await response.json();

      alert(result.message );
      console.log(result)
        setMessage(result.remoteFolderPath)

        setFiles([])
        setFormData(defauultForma)
    } catch (error) {
      alert("Błąd podczas wysyłania danych: " + error.message);
    }

    setLoading(false)
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(message)
    setCopyTxt("Skopiowano")
  }

   async function getFiltersData() {
      try {
  
        const docs = await fetchGet( API_URL+ '/' + reducer.choosenTable + "/options")
  
        dispatch({ type: SET_FILTERS_DATA, item: docs });
      } catch (err) {
        console.error(err);
        
        dispatch({ type: LOGOUT });
      }
    }

    useEffect(() => {
      getFiltersData()
    },[])

  return (
    <>
  
    <Header />
    {loading && 
      <Loading 
        info={"Proszę czekać, Dodajemy wizualizacje"}
        styles={{
          width:'100vw',
          height:'100vh',
          display:'flex',
          justifyContent:'center',
          alignItems:'center',
          position: 'fixed',
          top:'0',
          left:'0'
        }}
      /> 
    }

    <div className="slideshow">
    <form className="slideshow__form-wrapper">
      

   
      <div {...getRootProps()} style={{ 
          border: "0px dashed black", 
          padding: "10px", 
          marginBottom: "10px", 
          marginTop: "10px", 
          width:'100%', 
          minHeight:'300px',
          maxWidth:'80vw', 
          textAlign: 'center',
          backgroundColor:'white', 
          color:'var(--sec-font)'
          }}>
        <input {...getInputProps()} />
        <p>Dodaj pliki png, jpg, gif, mp4, webm</p>
        <div>
       
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", margin: '20px' }}>
          {files.map((file, index) => (
            <div key={index} style={{ display: "inline-block", textAlign: "center" }}>
              <img
                src={file.preview}
                alt={file.name}
                style={{ width: "100px", height: "auto", objectFit: "cover" }}
              />
              <p style={{ fontSize: "6px" }}>{file.name}</p>
            </div>
          ))}
        </div>

      </div>
      </div>

      <div className="slideshow-flex-row" style={{padding:'20px 0'}}>
        <h3 style={{paddingBottom:"10px"}}>Uzupełnij dane do kampanii</h3>
      </div>
        <div className="slideshow-flex-row">
        <InputText 
            placeholder="Kampania"
            value={formData.kampania}
            text="Kampania: "
            name="kampania"
            handleChange={(e) => handleChange(e)}
        />

        <InputText 
            placeholder="Klient"
            value={formData.klient}
            text="Klient: "
            name="klient"
            handleChange={(e) => handleChange(e)}
        />
        </div>
        
        <div className="slideshow-flex-row">

 {
            reducer.filtersData
              ?
              <label className="input-text__wrapper input-text__label-top">
              Format:
              {console.log(reducer)}
              <select onChange={(e) => handleChange(e)}    
           
                defaultValue={""}
                  className="login-form__input input-text"
                  text="Format: "
                  name="format"
              >
                 <option value={''}></option>
              {
                balansSort(reducer.filtersData.Format).map(item => 
                  <option value={item}>{item}</option>)
              }               
              </select>
              </label>

              : 
              <InputText 
            placeholder="Format"
            value={formData.format}
            text="Format: "
            name="format"
            handleChange={(e) => handleChange(e)}
        />
          }

    
          {
            reducer.filtersData
              ?
              <label className="input-text__wrapper input-text__label-top">
              Branża:
              <select onChange={(e) => handleChange(e)}    
                  className="login-form__input input-text"
                  text="Branża: "
                  name="branza"
                  defaultValue={""}
              >
                 <option value={''}></option>
              {
                balansSort(reducer.filtersData.Kategoria).map(item => 
                  <option value={item}>{item}</option>)
              }               
              </select>
              </label>

              : 
              <InputText 
            placeholder="Branża"
            value={formData.branza}
            text="Branża: "
            name="branza"
            handleChange={(e) => handleChange(e)}
        />
          }
     


        </div>
      


        <div className="slideshow-flex-row">
        <Button 
            txt="Wyślij"
            click={handleSubmit}
            styles={{
              width:'300px !important',
              margin: '0',
              backgroundColor:'black'
            }}
        />
        </div>


      <h3>{message &&
        <a style={{color:"var(--sec-font)"}} href={message}>{message}</a>
      }</h3>

      {
        message &&

        <div style={{
            width:'100vw',
            height:'100vh',
            backgroundColor:'var(--higlight-color)',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            position: 'fixed',
            top:'0',
            left:'0'
          }}>

          <Button 
              txt={copyTxt}
              styles={{
                backgroundColor:'black'
              }}
              click={handleCopy}
          />

          <h3>
            <a style={{
                color:"var(--main-color)",
                padding:'18px 30px',
                backgroundColor:'rgb(197, 146, 103)'
              }} 
              href={message}>{message}
            </a>
          </h3>

            <p 
              style={{
                color:'black',
                fontSize:'1.6rem',
                position:'absolute',
                top:'5%',
                cursor:'pointer',
                fontWeight:'700',
                right:'5%',
              }}

              onClick={
                () => {
                  setMessage("")
                }
              }
            >Zamknij</p>
        </div>
      }


    </form>
    </div>
    
    </>
  );
};

export default App;
